import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ItemService } from 'src/app/provider/item.service';

@Component({
  selector: 'kt-payment-types',
  templateUrl: './payment-types.component.html',
  styleUrls: ['./payment-types.component.scss']
})
export class PaymentTypesComponent implements OnInit, OnChanges, OnDestroy {

  constructor(
    public itemService: ItemService,
    private changeDetect: ChangeDetectorRef
  ) {
  }

  @Input() ID: number;

  subs: Subscription[] = [];

  ngOnInit() {

  }

  async ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = changes.ID.currentValue;
    this.itemService.getData(this.ID, 'menu-item');

    this.itemService.record_change$.subscribe(async (resp) => {
      this.changeDetect.detectChanges();
      if (resp.description.includes('card')) {
        resp.description = resp.description.replace('card', '');
      }

      if (resp.description.includes('drive')) {
        resp.description = resp.description.replace('drive', '');
      }
    });
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }

  onChange() {
    const data = this.itemService.record_change$.getValue();
    this.itemService.putItem(data);
  }

}
